//Typescript:
interface FeaturesArrType {
    id: number
    title: string
    subTitle?: string
    description: string
    icon: string
    color: string
}
const Features = () => {
    // Constants:
    const featuresArr = [
        {
            id:0,
            title: 'Hands-On Experience',
            description: 'Learn through expert-led live projects and gain real world experience',
            icon: '/assets/hand-on-experience.png',
            color: '#FAE0F3'
        },
        {
            id:1,
            title: 'Next Gen Skill Courses',
            description: 'Unlock your potential with our innovative courses designed to meet the demands of tomorrows world ',
            icon: '/assets/next-gen-skill-course.png',
            color: '#FBFDD1'
        },
        {
            id:2,
            title: 'Globally Recognised Certifications',
            subTitle: 'Ex- Microsoft, Intuit, IIT Guwahati',
            description: 'Acquire certifications from esteemed organizations like Microsoft, Intuit, and IIT Guwahati, demonstrating your proficiency.',
            icon: '/assets/globally-recognized-certifications.png',
            color: '#D0FDE0'
        },
        {
            id:3,
            title: 'Pathway to Education Abroad',
            description: 'Enhance your resume and increase your chances of admission to international institutions with our prestigious certification.',
            icon: '/assets/pathway-to-education-abroad.png',
            color: '#DFD4FF'
        },

    ]
    return <div className='col-[2_/_3] mb-[5rem] mt-[8rem] flex flex-col items-center justify-between'>
        <h2 className='text-[30px] md:text-[40px] font-extrabold mb-[40px] text-center'>Benefits of STEPskills courses</h2>
        <div className='flex gap-[35px] items-center justify-center lg:justify-start flex-wrap lg:flex-nowrap'>
            <div className='lg:basis-[50%] order-2 lg:order-1'>
            {featuresArr?.map((feature: FeaturesArrType)=><div className='flex justify-center items-center gap-[25px] mb-[20px] p-[16px] rounded-[20px]' style={{backgroundColor: feature?.color}} key={feature?.id}>
                        <img className='object-cover w-[50px] h-[50px]' src={feature.icon} alt='icon'/>
                    <div className='basis-[74%]'>
                        <h3 className='text-[20px] md:text-[25px] font-bold mt-[10px] md:mt-[0px]'>{feature.title}<br/> <span className='text-[20px] md:text-[22px] font-semibold'>{feature?.subTitle}</span></h3>
                        <p className='text-[18px]'>{feature.description}</p>
                    </div>
                </div>
            )}
            </div> 
                <img className='object-cover aspect-[545/537] w-[70%] lg:w-[50%] order-1 lg:order-2' src='/assets/features.png' alt='features'/>
          
        </div>
    </div>
}

export default Features